export default {
  PROFILE: 'PROFILE',
};
